{
  "title": "Investiture of Wind",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Until the spell ends, wind whirls around you, and you gain the following benefits:",
    "Ranged weapon attacks made against you have disadvantage on the attack roll.",
    "You gain a flying speed of 60 feet. If you are still flying when the spell ends, you fall, unless you can somehow prevent it.",
    "You can use your action to create a 15-foot cube of swirling wind centered on a point you can see within 60 feet of you. Each creature in that area must make a Constitution saving throw. A creature takes 2d10 bludgeoning damage on a failed save, or half as much damage on a successful one. If a Large or smaller creature fails the save, that creature is also pushed up to 10 feet away from the center of the cube."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
